import { AchievementStatus, StaffAchievementSearch } from '../../../../shared/models/staff-achievement.model';

export const achievementLabels: Record<AchievementStatus, string> = {
  below: 'Below target', on: 'On target', above: 'Above target', no_target: 'No target', unavailable: 'Comparison unavailable'
};
export const achievementColors: Record<AchievementStatus, string> = {
  below: '#b42318', on: '#175cd3', above: '#067647', no_target: '#667085', unavailable: '#667085'
};
export function countResultLabel(status: AchievementStatus, dailyTarget: number | null): string {
  if (status === 'no_target') { return dailyTarget > 0 ? 'No target days' : 'No count target'; }
  return {below: 'Under count target', on: 'On count target', above: 'Over count target', unavailable: 'Comparison unavailable'}[status];
}
export function achievementPercent(value: number | null, status?: AchievementStatus): string {
  if (value === null || value === undefined || !Number.isFinite(value)) { return 'N/A'; }
  const rounded = value.toFixed(2);
  if (rounded === '100.00' && (status === 'below' || (!status && value < 100))) { return '<100%'; }
  if (rounded === '100.00' && (status === 'above' || (!status && value > 100))) { return '>100%'; }
  return rounded + '%';
}
export function achievementRequest(search: StaffAchievementSearch, actionIds: number[] | null): StaffAchievementSearch {
  const request: StaffAchievementSearch = { when_from: search.when_from, when_to: search.when_to, action_ids: actionIds === null ? null : [...actionIds] };
  for (const key of ['include_weekends', 'excluded_staff_ids', 'created_by', 'created_by_group', 'brand_id', 'brand_report_id', 'brand_type_id', 'created_level', 'access_level', 'subject_id', 'subject_number', 'job_id', 'ip_address']) {
    if (search[key] !== undefined && search[key] !== null && search[key] !== '') { request[key] = search[key]; }
  }
  return request;
}
